import { render, staticRenderFns } from "./CounselorFilters.vue?vue&type=template&id=2148127d&"
import script from "./CounselorFilters.vue?vue&type=script&lang=js&"
export * from "./CounselorFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports